module.exports = __webpack_public_path__ + "static/media/chess-bishop-alt.4708e1c1.svg";